<template>
  <div>
    <span @click="search()">
      <Button
        type="primary"
        v-hasPermission="['permissionsConfigurationManagement:user:add_user']"
        @click="handleShowModal"
        >{{ $t("permission_configuration_management.user.addUser") }}</Button
      >
    </span>
    <Modal
      v-model="userModal"
      :title="$t('permission_configuration_management.user.addUser')"
      :loading="loading"
      @on-ok="userSubmit('userForm')"
      @on-cancel="userReset('userForm')"
      :mask-closable="false"
      :okText="$t('alarms.common.add')"
      :cancelText="$t('alarms.common.cancel')"
    >
      <Form
        ref="userForm"
        :model="userForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 公司 -->
        <div v-if="companyIdCookie == 1">
          <FormItem
            :label="$t('permission_configuration_management.account.company')"
            prop="companyId"
          >
            <Select
              v-model="userForm.companyId"
              style="width:300px;"
              @on-change="changeCompanyId"
              placeholder=" "
            >
              <Option
                :value="item.id"
                v-for="(item, index) in companyIdList"
                v-bind:key="index"
                >{{ item.companyName }}
              </Option>
            </Select>
          </FormItem>
        </div>
        <div v-else>
          <FormItem
            :label="$t('permission_configuration_management.account.company')"
            >{{ currentCompanyName }}</FormItem
          >
        </div>
        <!-- 用户名 -->
        <FormItem
          :label="$t('permission_configuration_management.user.userName')"
          prop="name"
        >
          <Input
            v-model="userForm.name"
            :placeholder="
              $t('permission_configuration_management.user.userName')
            "
            style="width:300px;"
          ></Input>
        </FormItem>
        <!-- 全名 -->
        <FormItem
          :label="$t('permission_configuration_management.user.fullName')"
          prop="fullName"
        >
          <Input
            v-model="userForm.fullName"
            :placeholder="
              $t('permission_configuration_management.user.fullName')
            "
            style="width:300px;"
          ></Input>
        </FormItem>
        <!-- 部门 -->
        <FormItem
          :label="$t('permission_configuration_management.user.department')"
          prop="department"
        >
          <Select
            v-model="userForm.department"
            style="width:300px;"
            @on-change="changeDepartment"
            placeholder=" "
          >
            <Option
              :value="item.id"
              v-for="(item, index) in departmentList"
              v-bind:key="index"
              >{{ item.name }}
            </Option>
          </Select>
        </FormItem>
        <!-- 职务 -->
        <FormItem
          :label="$t('permission_configuration_management.user.position')"
          prop="position"
        >
          <Select
            v-model="userForm.position"
            style="width:300px;"
            placeholder=" "
          >
            <Option
              :value="item.id"
              v-for="(item, index) in positionList"
              v-bind:key="index"
              >{{ item.name }}
            </Option>
          </Select>
        </FormItem>
        <!-- 邮箱 -->
        <FormItem
          :label="$t('permission_configuration_management.user.email')"
          prop="email"
        >
          <Input
            v-model="userForm.email"
            :placeholder="$t('permission_configuration_management.user.email')"
            style="width:300px;"
          ></Input>
        </FormItem>
        <!-- 角色 -->
        <FormItem
          :label="$t('permission_configuration_management.user.role')"
          prop="role"
        >
          <Select v-model="userForm.role" style="width:300px;" placeholder=" ">
            <Option :value="item.id" v-for="item in roleList" :key="item.id"
              >{{ item.name }}
            </Option>
          </Select>
        </FormItem>
        <!-- 密码 -->
        <FormItem
          :label="$t('permission_configuration_management.user.password')"
          prop="password"
        >
          <Input
            v-model="userForm.password"
            :placeholder="
              $t('permission_configuration_management.user.password')
            "
            style="width:300px;"
            type="password"
          ></Input>
        </FormItem>
        <!-- 确认密码 -->
        <FormItem
          :label="
            $t('permission_configuration_management.user.confirmPassword')
          "
          prop="confirmPassword"
        >
          <Input
            v-model="userForm.confirmPassword"
            :placeholder="
              $t('permission_configuration_management.user.confirmPassword')
            "
            style="width:300px;"
            type="password"
          ></Input>
        </FormItem>
        <!-- 是否开启短信验证 -->
        <FormItem
          :label="
            $t('permission_configuration_management.user.SMSVerification')
          "
          prop="msgCode"
        >
          <RadioGroup v-model="msgCode">
            <Radio :label="$t('common.yes')"></Radio>
            <Radio :label="$t('common.no')"></Radio>
          </RadioGroup>
        </FormItem>
        <!-- 开启短信验证 手机号为必填项 -->
        <FormItem
          :label="$t('permission_configuration_management.smsLogin.telPhone')"
          v-if="msgCode == $t('common.yes')"
        >
          <div class="tel-container">
            <Select v-model="areaCode" placeholder="+86">
              <Option
                :value="a.phone_code"
                :key="index"
                v-for="(a, index) in AreaCodeArr"
                :label="'+' + a.phone_code"
              >
                <span
                  >{{ "+" + a.phone_code }}&nbsp;{{ a.chinese_name }} (
                  {{ a.english_name }} )
                </span>
              </Option>
            </Select>
            <Input
              v-model="userForm.phone"
              type="number"
              style="width:229px;"
              :placeholder="
                $t('permission_configuration_management.smsLogin.plaTelPhone')
              "
            ></Input>
          </div>
        </FormItem>
        <FormItem
          v-if="msgCode == $t('common.yes')"
          :label="
            $t('permission_configuration_management.smsLogin.verificationCode')
          "
        >
          <div class="tel-container">
            <Input
              v-model="userForm.code"
              type="number"
              :placeholder="
                $t(
                  'permission_configuration_management.smsLogin.plaVerificationCode'
                )
              "
              :style="$i18n.locale == 'zh' ? 'width:205px' : 'width:160px'"
            ></Input>
            <Button
              type="text"
              :disabled="disabled"
              @click="sendCode"
              class="btn-text"
            >
              {{ text }}
            </Button>
          </div>
          <p style="color:#ed4014">{{ this.getErrMsg }}</p>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import TableUsers from "../user/TableUsers";
import AreaCode from "@/utils/AreaCode";
var tableUsers = TableUsers;
export default {
  data() {
    const pwdValidate = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("permission_configuration_management.user.passwordRequired")));
      } else {
        callback();
      }
    };
    const pwdCheckValidate = (rule, value, callback) => {
      if (this.userForm.password != "" && value == "") {
        callback(new Error(this.$t("permission_configuration_management.user.confirmPasswordRequired")));
      } else if (this.userForm.password != value) {
        callback(new Error(this.$t("permission_configuration_management.user.passwordMismatch")));
      } else {
        callback();
      }
    };
    return {
      currentCompanyName: "",
      companyIdCookie: getCookie(global.companyId),
      loading: true,
      userModal: false,
      companyIdList: [],
      departmentList: [],
      positionList: [],
      roleList: [],
      userForm: {
        name: "",
        position: "",
        department: "",
        fullName: "",
        companyId: "",
        email: "",
        password: "",
        confirmPassword: "",
        role: "",
        phone: "",
        mfaStatus: 0,
        code: "",
        id: ""
      },
      disabled: false,
      text: "",
      run: null,
      msgCode: "",
      AreaCodeArr: [],
      areaCode: 86,
      getErrMsg: "",
      ruleValidate: {
        name: [
          { required: true, message: this.$t("permission_configuration_management.user.pleaseInputUserName"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("permission_configuration_management.user.userNameLength100"),
            pattern: "^.{1,100}$",
            trigger: "blur"
          }
        ],
        position: [
          {
            required: true,
            message: this.$t("permission_configuration_management.user.pleaseSelectPosition"),
            trigger: "change",
            type: "number"
          }
        ],
        department: [
          {
            required: true,
            message: this.$t("permission_configuration_management.user.pleaseSelectDepartment"),
            trigger: "change",
            type: "number"
          }
        ],
        companyId: [
          {
            required: true,
            message: this.$t("permission_configuration_management.user.pleaseSelectCompany"),
            trigger: "change",
            type: "number"
          }
        ],
        fullName: [
          { required: true, message: this.$t("permission_configuration_management.user.pleaseInputFullName"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("permission_configuration_management.user.fullNameLength100"),
            pattern: "^.{1,100}$",
            trigger: "blur"
          }
        ],
        email: [
          { required: true, message: this.$t("permission_configuration_management.user.pleaseInputEmail"), trigger: "blur" },
          { type: "email", message: this.$t("permission_configuration_management.user.emailFormatError"), trigger: "blur" }
        ],
        password: [
          { required: true, validator: pwdValidate, trigger: "blur" },
          {
            message: this.$t("permission_configuration_management.user.passwordRule"),
            pattern: "^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,20}$",
            trigger: "blur"
          }
        ],
        confirmPassword: [
          { required: true, validator: pwdCheckValidate, trigger: "blur" },
          {
            message: this.$t("permission_configuration_management.user.passwordRule"),
            pattern: "^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,20}$",
            trigger: "blur"
          }
        ],
        role: [
          {
            required: true,
            message: this.$t("permission_configuration_management.user.pleaseSelectRole"),
            trigger: "change",
            type: "number"
          }
        ]
      }
    };
  },
  mounted() {
    this.AreaCodeArr = AreaCode.list;
    this.text = this.$t(
      "permission_configuration_management.smsLogin.getVerificationCode"
    );
  },
  methods: {
    sendCode() {
      if (!this.userForm.phone) {
        this.$Message.error(
          this.$t("permission_configuration_management.smsLogin.plaTelPhone")
        );
        return;
      }
      this.$api.user
        .sendSmsCode({
          id: "",
          phone: this.areaCode + "-" + this.userForm.phone
        })
        .then(res => {
          this.countDown();
          this.getErrMsg = "";
        })
        .catch(err => {
          this.getErrMsg = err.data.message;
        });
    },
    countDown() {
      if (this.disabled) return;
      this.disabled = true;
      let n = 60;
      this.text =
        n +
        "s" +
        this.$t("permission_configuration_management.smsLogin.surplusTime");
      this.run = setInterval(() => {
        n = n - 1;
        if (n < 1) {
          this.disabled = false;
          this.text = this.$t(
            "permission_configuration_management.smsLogin.Reacquire"
          );
          clearInterval(this.run);
          return;
        }
        this.text =
          n +
          "s" +
          this.$t("permission_configuration_management.smsLogin.surplusTime");
        if (
          this.text <
          0 +
            "s" +
            this.$t("permission_configuration_management.smsLogin.surplusTime")
        ) {
          this.disabled = false;
          this.text = this.$t(
            "permission_configuration_management.smsLogin.Reacquire"
          );
        }
      }, 1000);
    },
    handleShowModal() {
      this.userModal = true;
      this.msgCode = this.$t("common.no");
      this.getErrMsg = "";
    },
    // 查询
    search: function() {
      this.$api.user.listRegisterInformation().then(res => {
        // 公司列表
        this.companyIdList = res.data.companies;
        // 部门列表
        this.departmentList = res.data.departments;
      });
      if (this.companyIdCookie != 1) {
        this.getCompanyName();
        this.$api.user
          .queryRole("companyId", getCookie(global.companyId))
          .then(res => {
            this.roleList = res.data;
          });
      }
    },
    // 切换公司
    changeCompanyId: function() {
      this.userForm.role = "";
      if (this.userForm.companyId != undefined) {
        this.$api.user
          .queryRole("companyId", this.userForm.companyId)
          .then(res => {
            this.roleList = res.data;
          });
      }
    },
    // 职位
    listPositionByDepartment: function() {
      this.$api.user
        .listPositionByDepartment("departmentIndex", this.userForm.department)
        .then(res => {
          this.positionList = res.data;
        });
    },
    // 切换部门
    changeDepartment: function() {
      if (this.userForm.department != undefined) {
        this.listPositionByDepartment();
      }
    },
    // 查询当前用户公司名称
    getCompanyName: function() {
      this.$api.company
        .getCompanyName("companyId", getCookie(global.companyId))
        .then(res => {
          this.currentCompanyName = res.data;
        });
    },
    userSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.userForm.mfaStatus =
            this.msgCode == this.$t("common.no") ? 0 : 1;
          // 要判断用户是否选择了开启，先判断手机号校验 再请求接口
          if (this.userForm.mfaStatus == 1) {
            //   如果用户选择 短信校验 是 那么手机号码为必填项
            if (!this.userForm.phone) {
              this.$Message.error(
                this.$t(
                  "permission_configuration_management.smsLogin.plaTelPhone"
                )
              );
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              return;
            }
            // 如果开启短信验证 验证码为必填项
            if (!this.userForm.code) {
              this.$Message.error(
                this.$t(
                  "permission_configuration_management.smsLogin.plaVerificationCode"
                )
              );
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              return;
            }
          }
          this.submitData(name);
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
          this.$Message.error(this.$t("common.addFail"));
        }
      });
    },
    submitData(name) {
      var userDate = {
        name: this.userForm.name,
        email: this.userForm.email,
        position: this.userForm.position,
        department: this.userForm.department,
        fullName: this.userForm.fullName,
        password: this.userForm.password,
        role: this.userForm.role,
        mfaStatus: this.userForm.mfaStatus,
        phone: this.areaCode + "-" + this.userForm.phone,
        code: this.userForm.code,
        id: ""
      };

      if (this.companyIdCookie == 1) {
        userDate.companyId = this.userForm.companyId;
      } else if (this.companyIdCookie != 1) {
        userDate.companyId = getCookie(global.companyId);
      }

      // 添加
      this.$api.user
        .register(userDate)
        .then(res => {
          setTimeout(() => {
            tableUsers.methods.showAll();
            this.$refs[name].resetFields();
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.$Message.success(this.$t("common.addSuccess"));
            this.companyIdList = [];
            this.departmentList = [];
            this.positionList = [];
            this.roleList = [];
            this.userModal = false;
          }, 1000);
          clearInterval(this.run);
          this.disabled = false;
          this.text = this.$t(
            "permission_configuration_management.smsLogin.getVerificationCode"
          );
          this.getErrMsg = "";
        })
        .catch(err => {
          this.getErrMsg = err.data.message;
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        });
    },
    userReset: function(name) {
      this.companyIdList = [];
      this.departmentList = [];
      this.positionList = [];
      this.roleList = [];
      this.$refs[name].resetFields();
      clearInterval(this.run);
      this.disabled = false;
      this.text = this.$t(
        "permission_configuration_management.smsLogin.getVerificationCode"
      );
    }
  }
};
</script>
<style scoped>
.tel-container {
  display: flex;
  border: 1px solid #dcdee2;
  border-radius: 5px;
  width: 300px;
  align-items: center;
}
.tel-container >>> .ivu-input {
  border: none;
}
.tel-container >>> .ivu-select-single .ivu-select-selection {
  background: none;
  border: none;
  outline: none;
  border: none;
}
/* 去掉点击下拉框时的阴影 */
.tel-container >>> .ivu-select-single .ivu-select-selection:focus {
  box-shadow: 0 0 02px transparent;
}
.tel-container >>> .ivu-select-selected-value {
  color: #515a6e;
  text-align: center;
}
.tel-container
  >>> .ivu-select-single
  .ivu-select-selection
  .ivu-select-placeholder {
  color: #515a6e;
  text-align: center;
}
.tel-container >>> .ivu-select {
  width: 70px;
}
.tel-container >>> input::-webkit-outer-spin-button,
.tel-container >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.tel-container >>> input[type="number"] {
  -moz-appearance: textfield;
}
.btn-text {
  background: none;
}
.btn-text:hover {
  background: none;
}
/* 去掉点击下拉框时的阴影 */
.btn-text:focus {
  box-shadow: 0 0 0 2px transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/user/AddUsers.vue